import { PerdiemsStore, NewPerdiemStore, ChangePerdiemStore } from './perdiems-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new PerdiemsStore());
  storeBuilder.addRepository(new NewPerdiemStore());
  storeBuilder.addRepository(new ChangePerdiemStore());
}
